import React from "react";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
import { Tooltip } from "flowbite-react";

const PublishButton = ({ openPublishConfirm, hasReviewRequest }) => {
  return (
    <div className="relative">
      <button
        onClick={openPublishConfirm}
        className="
        inline-flex items-center justify-center gap-2 text-sm rounded-md transition h-10 pl-4 pr-5 whitespace-nowrap 
        bg-primary hover:bg-secondary hover:ring-4 ring-gray-200 dark:ring-gray-700 text-white"
      >
        <span className="sr-only">Publish button</span>
        <HiOutlineRocketLaunch size={20} />
        Publish
      </button>

      {hasReviewRequest && (
        <Tooltip content="Review request pending">
          <div className="absolute -top-1 -right-1">
            <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
            <div className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full animate-ping"></div>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default PublishButton;
